import React from 'react';
import PropTypes from 'prop-types';

export default class DropdownList extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		actions: PropTypes.array,
		itemComponent: PropTypes.func
	};

	static defaultProps = {
		actions: []
	};

	render() {
		return (
			<ul id={this.props.id} className="dropdown-content dropdown-menu-content">
				{this.renderActions()}
			</ul>
		);
	}

	renderActions() {
		let ItemComponent = this.props.itemComponent;

		return this.props.actions.map((actionProps, index) => {
			return (
				<li key={"dropdown_list_button__" + index}>
					<ItemComponent {...actionProps} element="a" clearTheme={true} />
				</li>
			);
		});
	}
}
